export default "__VITE_ASSET__dZoAX8WM__"